import { AppState } from 'mk2/reducers';
import {
    initialForumTopicsPageState,
    initialSearchState,
    ForumTopicsPageState,
    SearchState,
} from './ForumTopics.reducers';

export const getForumTopicsState = (state: AppState): ForumTopicsPageState =>
    state.containers.forum.forumTopics || initialForumTopicsPageState;

export const getForumTopicsSearchState = (state: AppState, category: string, search: string): SearchState => {
    const forumTopicsState = getForumTopicsState(state);
    return forumTopicsState.categories[category] && forumTopicsState.categories[category][search]
        ? forumTopicsState.categories[category][search]
        : initialSearchState;
};
